<div id="alerts">
  @if (alerts?.length==0) {
    <div>
      Aucune alerte
    </div>
  }

  @for (alert of alerts; track alert; let i = $index) {
    <div class= "alert">
      <h5 >
        Alerte {{ alert.id }} - @if (alert.criteria.businessLine !== undefined) {
        <span  >{{ alert.criteria.businessLine }} </span>
      }
      <!--
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Alert" (click) = "updateAlertStatus(i, alert)" [style.color]="alert.active ? '#008000':'#ff0000'"><mat-icon>notifications_active</mat-icon> {{alert.active?"Désactiver":"Activer"}} </button>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Alert" (click) = "executeAlert(alert)" ><mat-icon>search</mat-icon> Exécuter </button>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Edit" (click) = "editAlert(i)"><mat-icon>edit</mat-icon> Editer </button>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Delete" (click) = "deleteAlert(i)"><mat-icon>delete</mat-icon> Supprimer </button>
      -->
    </h5>
    <h6>
      @if (alert.criteria.makes !== undefined) {
        <span  >Marques: {{ alert.criteria.makes }} , </span>
      }
      @if (alert.criteria.models !== undefined) {
        <span >Modeles: {{ alert.criteria.models }}, </span>
      }
      @if (alert.criteria.countries !== undefined) {
        <span >Pays: {{ alert.criteria.countries }}, </span>
      }
      @if (alert.criteria.cities !== undefined) {
        <span >Villes: {{ alert.criteria.cities }}, </span>
      }
      @if (alert.criteria.fuels !== undefined) {
        <span >Carburant: {{ alert.criteria.fuels }}, </span>
      }
      @if (alert.criteria.gearBoxes !== undefined) {
        <span >Boites: {{ alert.criteria.gearBoxes }}, </span>
      }
      <span >Année: De {{ alert.criteria.yearMin }} à {{ alert.criteria.yearMax }}, </span>
      <span >Prix: De {{ alert.criteria.priceMin }} à {{ alert.criteria.priceMax }} XAF, </span>
      <span >Dates: Du {{ dateFormat(alert.criteria.startDate) }} au {{ dateFormat(alert.criteria.endDate) }}, </span>
    </h6>
    <div class="alert-buttons">
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Alert" (click)="updateAlertStatus(alert)" [style.color]="alert.active ? '#008000':'#ff0000'"><mat-icon>notifications_active</mat-icon> {{alert.active?"Désactiver":"Activer"}} </button>
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Alert" (click)="executeAlert(alert)" ><mat-icon>search</mat-icon> Exécuter </button>
      <!-- <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Edit" (click) = "editAlert(i)"><mat-icon>edit</mat-icon> Editer </button>
      -->
      <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Delete" (click)="deleteAlert(alert.criteria.businessLine!, alert.id)"><mat-icon>delete</mat-icon> Supprimer </button>
    </div>
  </div>
}
</div>
